import * as Backbone from "backbone";
import {InsecureCachingCollection} from "./_BaseCollection";

export class AppWidgetCollection extends InsecureCachingCollection<Backbone.Model> {
    url = () => {
        return window.location.origin + '/api/v1/apps/widgets';
    };

    comparator = (model) => {
        return model.get('name');
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/AppWidgets.ts